<template>
  <div>
    <v-btn small text color="primary" @click="exportUsers">
      <v-icon left>mdi-download</v-icon>
      Tout Exporter
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'UsersButtons',
  data () {
    return {}
  },
  methods: {
    async exportUsers () {
      this.$bus.emit('ui/download', (await this.$api.get('users/export', { with_usage: true }, { timeout: 30000 })).data.file)
    }
  }
}
</script>